import {
  ROLE_PLATFORM_HIXME_ADMIN,
  ROLE_CLIENT_ADMIN,
} from '@hixme/role-policy'
import InvoiceList from './pages/InvoiceList/InvoiceList'
import { FUNDING_INVOICE_PATH } from './constants'
import authOnEnter from 'enrollment-platform/authOnEnter'
import AdminPortalGate from 'enrollment-platform/rbac/AdminPortalGate'
import { abilityOnEnter } from 'enrollment-platform/rbac/abilityOnEnter'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'

const FundingInvoiceRoutes = {
  path: FUNDING_INVOICE_PATH,
  component: AdminPortalGate,
  onEnter(_nextState, replace, callback) {
    // Role check first (existing), then DB ability: Read on FundingInvoice.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN],
      callback: (err?: { status: number; message: string }) =>
        err
          ? callback(err)
          : abilityOnEnter({
              action: RbacActions.Read,
              subject: RbacSubjects.FundingInvoice,
              replace,
              callback,
            }),
    })
  },
  indexRoute: {
    onEnter(
      nextState: { location: { search: string } },
      replace: (path: string) => void
    ) {
      replace(`/funding-invoice/invoice-list${nextState.location.search}`)
    },
  },
  childRoutes: [
    {
      path: 'invoice-list',
      component: InvoiceList,
    },
  ],
}

export default FundingInvoiceRoutes
